import { render, staticRenderFns } from "./Separador.vue?vue&type=template&id=a9751942&"
import script from "./Separador.vue?vue&type=script&lang=js&"
export * from "./Separador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports